import { useState } from "react"
import { DialogContent, DialogTitle, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import { OkCancel } from "lib/@components/okCancel"
import { useTreeItem } from "routes/schedule/lib/useTreeItem"
import { BasketLimit } from "../basket-limit"

const FAVOURTIES_LIMIT = 1000

export function CreateBasketDialog() {
    const [name, setName] = useState("")
    const favouritesListsCount = useTreeItem("basket-ScheduleBasket")?.children?.length ?? 0

    const basket = useTreeItem("basket-ScheduleBasket")
    const errorDoubleName = basket?.children?.some((child) => child.label.toLowerCase() === name.toLowerCase())
    const errorMsg = errorDoubleName ? "There is already an item with the same name in your Favourites list" : ""

    return (
        <BasketLimit itemType={"favourites list"} itemCount={favouritesListsCount} itemLimit={FAVOURTIES_LIMIT}>
            <DialogTitle>Create a favourites list of schedules</DialogTitle>
            <DialogContent>
                <TextField
                    data-cy="create-basket-name-text-field"
                    autoFocus
                    sx={{ mt: 2 }}
                    variant="outlined"
                    label="List name"
                    fullWidth
                    value={name}
                    onChange={setFromEvent(setName)}
                    error={errorDoubleName}
                    helperText={errorMsg}
                />
            </DialogContent>
            <OkCancel value={name} okDisabled={errorDoubleName} />
        </BasketLimit>
    )
}
